import type { PageMinimapFragment } from "../client/generated";
import { MiniMap } from "react-zoom-pan-pinch";
import { Page } from "./Page";
import { Badge } from "@acdc2/ui/components/badge";

type Props = {
  fragment: PageMinimapFragment;
};

export function PageMinimap({ fragment }: Props) {
  return (
    <div className="fixed z-10 top-4 right-4 shadow">
      <MiniMap borderColor="var(--color-brand)">
        <Page fragment={fragment} />
      </MiniMap>
      <div className="absolute bottom-0 right-0 z-10 p-2">
        <Badge>{fragment.index}</Badge>
      </div>
    </div>
  );
}
